export enum MessageType {
	Email = 6300,
	SMS = 6310
}